import React, { Component } from 'react'
import './styles.sass'
import MultiSelect from '../MultiSelect/MultiSelect';
import Draggable from "gsap/Draggable";
import MultiSelectHour from '../MultiSelectHour/MultiSelectHour';

export default class BannerWeek extends Component {
  constructor(props) {
    super(props)

    this.state = {
      tagSelected: [],
      openFilter: false,
      indexFilter: ""
    }
  }

  handleOpenSelect = (index, open) => {
    this.setState({
      indexFilter: open ? index : ""
    })
  }

  handleClick = (index, e) => {
    e.preventDefault()
    const { callbackDay } = this.props
    if(callbackDay) callbackDay( index )
  }

  handleChangeWeek = (type) => {
    const { callbackChangeWeek } = this.props
    if(callbackChangeWeek) callbackChangeWeek( type, this.props.daySelected )
  }

  componentDidMount() {      
    this.initList()
  }

  initList = () => {
    this.draggable = Draggable.create("#wrapper-list-scroll", {type:"scrollLeft", edgeResistance:0.9, throwProps:false });
  }

  render() {
    let orarioFrom = {
      "name": this.props.labels.filterTime_hours,
      "labelAllSelected": "",
      "labelMultiSelected": "",
      "multiSelect": false,
      "options": [
        {
          "id": 999,
          "category": "ORA",
          "isChecked": false,
          "items": [
            {
              "id": 91,
              "label": "07:00",
              "isChecked": true
            },
            {
              "id": 92,
              "label": "07:30",
              "isChecked": false
            },
            {
              "id": 93,
              "label": "08:00",
              "isChecked": false
            },
            {
              "id": 1,
              "label": "08:30",
              "isChecked": false
            },
            {
              "id": 2,
              "label": "09:00",
              "isChecked": false
            },
            {
              "id": 3,
              "label": "09:30",
              "isChecked": false
            },
            {
              "id": 4,
              "label": "10:00",
              "isChecked": false
            },
            {
              "id": 5,
              "label": "10:30",
              "isChecked": false
            },
            {
              "id": 6,
              "label": "11:00",
              "isChecked": false
            },
            {
              "id": 7,
              "label": "11:30",
              "isChecked": false
            },
            {
              "id": 8,
              "label": "12:00",
              "isChecked": false
            },
            {
              "id": 9,
              "label": "12:30",
              "isChecked": false
            },
            {
              "id": 10,
              "label": "13:00",
              "isChecked": false
            },
            {
              "id": 11,
              "label": "13:30",
              "isChecked": false
            },
            {
              "id": 12,
              "label": "14:00",
              "isChecked": false
            },
            {
              "id": 13,
              "label": "14:30",
              "isChecked": false
            },
            {
              "id": 14,
              "label": "15:00",
              "isChecked": false
            },
            {
              "id": 15,
              "label": "15:30",
              "isChecked": false
            },
            {
              "id": 16,
              "label": "16:00",
              "isChecked": false
            },
            {
              "id": 17,
              "label": "16:30",
              "isChecked": false
            },
            {
              "id": 18,
              "label": "17:00",
              "isChecked": false
            },
            {
              "id": 19,
              "label": "17:30",
              "isChecked": false
            },
            {
              "id": 20,
              "label": "18:00",
              "isChecked": false
            },
            {
              "id": 21,
              "label": "18:30",
              "isChecked": false
            },
            {
              "id": 22,
              "label": "19:00",
              "isChecked": false
            },
            {
              "id": 23,
              "label": "19:30",
              "isChecked": false
            },
            {
              "id": 24,
              "label": "20:00",
              "isChecked": false
            },
            {
              "id": 25,
              "label": "20:30",
              "isChecked": false
            },
            {
              "id": 26,
              "label": "21:00",
              "isChecked": false
            },
            {
              "id": 27,
              "label": "21:30",
              "isChecked": false
            },
            {
              "id": 28,
              "label": "22:00",
              "isChecked": false
            },
            {
              "id": 29,
              "label": "22:30",
              "isChecked": false
            },
            {
              "id": 30,
              "label": "23:00",
              "isChecked": false
            },
            {
              "id": 31,
              "label": "23:30",
              "isChecked": false
            },
            {
              "id": 32,
              "label": "24:00",
              "isChecked": false
            }
          ]
        }
      ]
    }
    let orarioOf = {
      "name": this.props.labels.filterTime_hours,
      "labelAllSelected": "",
      "labelMultiSelected": "",
      "multiSelect": false,
      "options": [
        {
          "id": 999,
          "category": "ORA",
          "isChecked": false,
          "items": [
            {
              "id": 91,
              "label": "07:00",
              "isChecked": false
            },
            {
              "id": 92,
              "label": "07:30",
              "isChecked": false
            },
            {
              "id": 93,
              "label": "08:00",
              "isChecked": false
            },
            {
              "id": 1,
              "label": "08:30",
              "isChecked": false
            },
            {
              "id": 2,
              "label": "09:00",
              "isChecked": false
            },
            {
              "id": 3,
              "label": "09:30",
              "isChecked": false
            },
            {
              "id": 4,
              "label": "10:00",
              "isChecked": false
            },
            {
              "id": 5,
              "label": "10:30",
              "isChecked": false
            },
            {
              "id": 6,
              "label": "11:00",
              "isChecked": false
            },
            {
              "id": 7,
              "label": "11:30",
              "isChecked": false
            },
            {
              "id": 8,
              "label": "12:00",
              "isChecked": false
            },
            {
              "id": 9,
              "label": "12:30",
              "isChecked": false
            },
            {
              "id": 10,
              "label": "13:00",
              "isChecked": false
            },
            {
              "id": 11,
              "label": "13:30",
              "isChecked": false
            },
            {
              "id": 12,
              "label": "14:00",
              "isChecked": false
            },
            {
              "id": 13,
              "label": "14:30",
              "isChecked": false
            },
            {
              "id": 14,
              "label": "15:00",
              "isChecked": false
            },
            {
              "id": 15,
              "label": "15:30",
              "isChecked": false
            },
            {
              "id": 16,
              "label": "16:00",
              "isChecked": false
            },
            {
              "id": 17,
              "label": "16:30",
              "isChecked": false
            },
            {
              "id": 18,
              "label": "17:00",
              "isChecked": false
            },
            {
              "id": 19,
              "label": "17:30",
              "isChecked": false
            },
            {
              "id": 20,
              "label": "18:00",
              "isChecked": false
            },
            {
              "id": 21,
              "label": "18:30",
              "isChecked": false
            },
            {
              "id": 22,
              "label": "19:00",
              "isChecked": false
            },
            {
              "id": 23,
              "label": "19:30",
              "isChecked": false
            },
            {
              "id": 24,
              "label": "20:00",
              "isChecked": false
            },
            {
              "id": 25,
              "label": "20:30",
              "isChecked": false
            },
            {
              "id": 26,
              "label": "21:00",
              "isChecked": false
            },
            {
              "id": 27,
              "label": "21:30",
              "isChecked": false
            },
            {
              "id": 28,
              "label": "22:00",
              "isChecked": false
            },
            {
              "id": 29,
              "label": "22:30",
              "isChecked": false
            },
            {
              "id": 30,
              "label": "23:00",
              "isChecked": false
            },
            {
              "id": 31,
              "label": "23:30",
              "isChecked": false
            },
            {
              "id": 32,
              "label": "24:00",
              "isChecked": true
            }
          ]
        }
      ]
    }
    const { weekList, daySelected,timeFromTxt, timeOfTxt, labels } = this.props
    const { indexFilter } = this.state

    return (
      <section className="banner-week">
        <div className="view-all"><a target="_blank" href={weekList.currentWeek.fullCalendar}>{labels.link_palinsesto}</a></div>
        <div className="weekly-calendar">
          <div id="wrapper-list-scroll">
            <div className={`prev-week ${weekList.currentWeek.prevWeek && weekList.currentWeek.prevWeek.length > 0 ? 'active' : 'disable'}`}><a onClick={ () => weekList.currentWeek.prevWeek && weekList.currentWeek.prevWeek.length > 0 ? this.handleChangeWeek("prevWeek") : ""} className={weekList.currentWeek.prevWeek && weekList.currentWeek.prevWeek.length > 0 ? '' : 'disable'}>{labels.calendarBar_prev_week}</a></div>
            <div className="current-week">
              <ul className="days">
                
                  {
                    weekList.currentWeek.daysOfWeek.map((day, index) => {
                      return <li className={index == daySelected ? "active" : ""} ><button onClick={(e) => this.handleClick(index, e)}><div className="label-day">{day.labelDay}{day.today ? <span className='today'>  (oggi)</span> : ""}</div><div><span>{day.numberDay} </span>{day.labelMonth}</div></button></li>
                    })
                  }
                
              </ul>
            </div>
            <div className={`next-week ${weekList.currentWeek.nextWeek && weekList.currentWeek.nextWeek.length > 0 ? 'active' : 'disable'}`}><a onClick={ () => weekList.currentWeek.nextWeek && weekList.currentWeek.nextWeek.length > 0 ? this.handleChangeWeek("nextWeek") : ""}  className={weekList.currentWeek.nextWeek && weekList.currentWeek.nextWeek.length > 0 ? '' : 'disable'}>{labels.calendarBar_next_week}</a></div>
          </div>
        </div>
        <div className="hour-filter">{labels.filterTime_timeFrom}
          <MultiSelectHour itemsList={orarioFrom} labelSelection={"ORARIO"} smallSelect={true} timeTxt={timeFromTxt} orario="timeFrom" index="0" callbackHour={this.props.callbackHour} callbackOpen={(indexMulti, open) => this.handleOpenSelect(indexMulti, open)} open={indexFilter === "0"}  />
          {labels.filterTime_timeTo}
          <MultiSelectHour itemsList={orarioOf} labelSelection={"ORARIO"} smallSelect={true} timeTxt={timeOfTxt} orario="timeOf" index="1" callbackHour={this.props.callbackHour} callbackOpen={(indexMulti, open) => this.handleOpenSelect(indexMulti, open)} open={indexFilter === "1"} />
        </div>
      </section>
    )
  }
}
